<template>
	<main class="organization-settings-change-plan relative">
		<div v-if="!loading" class="change-plan__container">
			<ValidationObserver ref="observer">
				<form @submit.prevent="() => updatePlan(isCustomerAddressValidationEnabled)">
					<template v-if="publishableKey">
						<SubscriptionBilling
							ref="subscriptionBilling"
							data-testid="subscription-billing"
							:summary="true"
							:stripe-key="publishableKey"
							:subscription-view-model="viewModel"
							:error-message="cardErrorMessage"
							@upgrade-ready="updateInfo"
							@address-updated="updateSubscriptionCost"
							@tax-info-updated="updateSubscriptionCost"
							@set-errors="setErrors"
							@submit="updatePlan"
						/>
					</template>
				</form>
			</ValidationObserver>
		</div>
		<template v-else>
			<div v-for="n in 6" :key="n" class="skeleton" :class="n % 2 === 0 ? 'mb-4' : 'mb-3'"></div>
		</template>
	</main>
</template>

<script lang="ts">
	import { defineComponent, toRef } from 'vue';
	import type { PropType } from 'vue';
	import { ValidationObserver } from 'vee-validate';
	import SubscriptionBilling from '../../../../components/app/SubscriptionBilling.vue';
	import { useCheckoutBilling } from './use-checkout-billing';
	import type { AnnualCommitments } from './use-checkout-billing';
	import type { SubscriptionSettingsViewModel } from '@cognitoforms/api/services/subscription-service';

	export default defineComponent({
		components: {
			SubscriptionBilling,
			ValidationObserver
		},
		props: {
			plan: { type: String, required: true },
			annualCommitments: { type: Object as PropType<AnnualCommitments | null>, default: null },
			onSubmit: { type: Function as PropType<(model: SubscriptionSettingsViewModel) => Promise<void>>, default: null }
		},
		emits: ['loading', 'change-plan-status', 'handle-close', 'cost-updated', 'cost-loading', 'cost-throttled'],
		setup(props, { emit }) {
			return useCheckoutBilling({
				plan: props.plan,
				emit,
				annualCommitments: toRef(props, 'annualCommitments'),
				onSubmit: props.onSubmit ?? undefined
			});
		}
	});
</script>

<style lang="scss">
@import '@cognitoforms/styles/app/common/checkout-flow-layout';

.organization-settings-change-plan {
	@include checkout-skeleton;
}
</style>